import { render } from "./ServiceVerify.vue?vue&type=template&id=645e8772&scoped=true"
import script from "./ServiceVerify.vue?vue&type=script&lang=js"
export * from "./ServiceVerify.vue?vue&type=script&lang=js"

import "./ServiceVerify.vue?vue&type=style&index=0&id=645e8772&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645e8772"]])

export default __exports__